<template>
  <div>
    <v-row>
      <v-col md="3">
        <v-text-field
          hide-details="auto"
          type="date"
          solo
          flat
          background-color="grey lighten-4"
          v-model="searchParams.start_date"
          label="Data Inicial"
        />
      </v-col>
      <v-col md="3">
        <v-text-field
          hide-details="auto"
          type="date"
          solo
          flat
          background-color="grey lighten-4"
          v-model="searchParams.end_date"
          label="Data Final"
        />
      </v-col>

      <v-col md="3">
        <v-select
          v-model="searchParams.action"
          :items="actionOptions"
          label="Ação"
          solo
          flat
          background-color="grey lighten-4"
          clearable
          hide-details="auto"
        />
      </v-col>
      <v-col md="1">
        <v-btn
          color="primary"
          block
          large
          @click="select(1)"
          :loading="isLoading"
        >
          <v-icon left>mdi-magnify</v-icon>
          Pesquisar
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="5">
        <EmployeeSelect
          v-model="searchParams.employee_id"
          label="Funcionário"
          :item-value="(val) => val.id"
          :itemText="(val) => val.short_name"
          solo
          flat
          background-color="grey lighten-4"
          :dense="false"
          clearable
        />
      </v-col>
    </v-row>

    <v-row class="mt-6">
      <v-col>
        <v-card flat color="grey lighten-4">
          <v-card-title class="d-flex justify-space-between mb-4 pt-5">
            <span class="text-subtitle-1">Histórico de Sessões</span>
          </v-card-title>
          <v-card-text>
            <v-data-table
              class="grey lighten-4"
              :headers="headers"
              :items="sessionLogs.data"
              hide-default-footer
              :items-per-page="-1"
              disable-sort
            >
              <template v-slot:item.employee="{ item }">
                <div class="font-weight-medium">
                  {{ item.employee ? item.employee.name : "-" }}
                </div>
                <div class="text-caption grey--text">
                  {{ item.employee ? item.employee.username : "" }}
                </div>
              </template>

              <template v-slot:item.action="{ item }">
                <v-chip
                  small
                  :color="
                    item.action === 'login' ? 'success' : 'grey-lighten-1'
                  "
                  variant="text"
                >
                  {{ item.action === "login" ? "Login" : "Logout" }}
                </v-chip>
              </template>

              <template v-slot:item.is_active="{ item }">
                <v-chip
                  v-if="item.action === 'login'"
                  small
                  :color="item.is_active ? 'primary' : 'grey-lighten-1'"
                >
                  {{ item.is_active ? "Ativa" : "Encerrada" }}
                </v-chip>
                <span v-else>-</span>
              </template>

              <template v-slot:item.ip_address="{ item }">
                {{ item.ip_address || "-" }}
              </template>

              <template v-slot:item.device="{ item }">
                {{ item.device || "-" }}
              </template>

              <template v-slot:item.device_model="{ item }">
                {{ item.device_model || "-" }}
              </template>

              <template v-slot:item.browser="{ item }">
                {{ item.browser || "-" }}
              </template>

              <template v-slot:item.created_at="{ item }">
                {{ formatDate(item.created_at) }}
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  v-if="item.action === 'login' && item.is_active"
                  small
                  color="error"
                  outlined
                  @click.stop="revokeSession(item)"
                >
                  <v-icon small left>mdi-logout</v-icon>
                  Deslogar
                </v-btn>
                <span v-else>-</span>
              </template>
            </v-data-table>

            <app-pagination @click="select($event)" :data="sessionLogs" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="revokeDialog" max-width="450">
      <v-card>
        <v-card-title class="text-h6">
          Revogar Sessão
        </v-card-title>
        <v-card-text>
          Deseja realmente deslogar a sessão de
          <strong>{{ revokeTarget ? revokeTarget.employee.name : "" }}</strong
          >?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="revokeDialog = false">
            Cancelar
          </v-btn>
          <v-btn color="error" :loading="isRevoking" @click="confirmRevoke">
            Deslogar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { format, startOfMonth, parseISO } from "date-fns";
import EmployeeSelect from "@/components/employees/ui/EmployeeSelect.vue";

export default {
  components: {
    EmployeeSelect,
  },

  data() {
    return {
      headers: [
        { text: "Funcionário", value: "employee", align: "start" },
        { text: "Ação", value: "action", align: "center" },
        { text: "Sessão", value: "is_active", align: "center" },
        { text: "IP", value: "ip_address", align: "start" },
        { text: "Dispositivo", value: "device", align: "start" },
        { text: "Modelo", value: "device_model", align: "start" },
        { text: "Navegador", value: "browser", align: "start" },
        { text: "Data/Hora", value: "created_at", align: "start" },
        { text: "Ações", value: "actions", align: "center", sortable: false },
      ],

      actionOptions: [
        { text: "Login", value: "login" },
        { text: "Logout", value: "logout" },
      ],

      sessionLogs: {
        data: [],
      },

      searchParams: {
        start_date: format(startOfMonth(new Date()), "yyyy-MM-dd"),
        end_date: format(new Date(), "yyyy-MM-dd"),
        employee_id: null,
        action: null,
        page: 1,
      },

      isLoading: false,
      revokeDialog: false,
      revokeTarget: null,
      isRevoking: false,
    };
  },

  methods: {
    async select(page = 1) {
      this.searchParams.page = page;
      this.isLoading = true;

      try {
        let params = { ...this.searchParams };

        if (params.employee_id && params.employee_id.id) {
          params.employee_id = params.employee_id.id;
        }

        const response = await this.$http.index("employee/session-log", params);

        this.sessionLogs = response;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    formatDate(date) {
      if (!date) return "-";
      return format(parseISO(date), "dd/MM/yyyy HH:mm:ss");
    },

    revokeSession(item) {
      this.revokeTarget = item;
      this.revokeDialog = true;
    },

    async confirmRevoke() {
      this.isRevoking = true;

      try {
        await this.$http.destroy("employee/session-log", this.revokeTarget.id);
        this.revokeTarget.is_active = false;
        this.revokeDialog = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.isRevoking = false;
      }
    },
  },

  mounted() {
    this.select();
  },
};
</script>
